module.exports = __webpack_public_path__ + "static/img/bg7.89e71d75.png";